import { IAction, IActionMethods, StateStatus } from '../../utils/common';
import * as Types from './types';
import * as AuthenticationService from '../../../services/api/authenticate';
import { Dispatch } from 'redux';
import NavigationConfig from '../../../navigation/config';
// import { AuthRoles } from '../../../config';
import { getState } from '../../store';
import { ReducerKeys } from '..';
import _ from 'lodash';
// import { showToastAction } from '../../../components/atoms/toast_message';
// import { LanguagesEnum } from '../../../config/languages';

/** Authenticate Action  */

interface IAutheticateInput {
  username: string;
  password: string;
  stayLogin: boolean;
}

interface IAutheticateOutput {
  token: string;
  refreshToken: string;
  role: string;
  id: string;
  stayLogin: boolean;
  email: string;
  username: string;
}

class Authenticate implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.LOGIN_TYPE,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(result: IAutheticateOutput): IAction {
    const data = {
      role: result.role,
      token: result.token,
      refreshToken: result.refreshToken,
      stayLogin: result.stayLogin,
      data: {
        username: result.username,
        email: result.email,
      },
    };

    return {
      type: Types.LOGIN_TYPE,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.LOGIN_TYPE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(data: IAutheticateInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        // console.log('Result:...');
        const result = await AuthenticationService.authenticateUser({
          username: data.username,
          password: data.password,
        });
        // console.log('Result:', result);
        dispatch(
          this.onSuccess({
            token: result.access_token,
            role: result.user.role,
            id: result.user.uuid,
            stayLogin: data.stayLogin,
            refreshToken: result.access_token,
            email: _.get(result.user, 'data.email', 'Email Not Found'),
            username: _.get(result.user, 'data.username', 'Username Not Found'),
          })
        );
      } catch (error: any) {
        // console.log('Authenticate Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

/** Logout Action  */

class Logout implements IActionMethods {
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.LOGOUT_TYPE,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.LOGOUT_TYPE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(history?: any): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onSuccess());
        // localStorage.clear();
        // window.location.reload();
      } catch (error: any) {
        localStorage.clear();
        // console.log('Logout Error:', error.message);
        dispatch(this.onFailed());
      } finally {
        localStorage.clear();
        if (history) {
          history.push(NavigationConfig.loginPage().path);
        }
      }
    };
  }
}

/** Refresh Token Action  */

interface IRefreshTokenInput {
  token: string;
  refreshToken: string;
}

interface IRefreshTokenOutput {
  token: string;
  refreshToken: string;
}

class RefreshToken implements IActionMethods {
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: IRefreshTokenOutput): IAction {
    throw new Error('Method not implemented.');
  }

  onFailed(): IAction {
    throw new Error('Method not implemented.');
  }

  action(data: IRefreshTokenInput): IAction {
    return new Authenticate().onSuccess({
      token: data.token,
      refreshToken: data.refreshToken,
      stayLogin: true,
      role: getState(ReducerKeys.AUTH_REDUCER).role,
      id: getState(ReducerKeys.AUTH_REDUCER).id,
      username: getState(ReducerKeys.AUTH_REDUCER).data.username,
      email: getState(ReducerKeys.AUTH_REDUCER).data.email,
    });
  }
}

class Version implements IActionMethods {
  onPending(result?: any): IAction {
    return {
      type: Types.VERSION_TYPE,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(version: string): IAction {
    return {
      type: Types.VERSION_TYPE,
      status: StateStatus.Success,
      data: version,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.VERSION_TYPE,
      status: StateStatus.Failed,
      data: null,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        const result = await AuthenticationService.fetchVersion();
        dispatch(this.onSuccess(result));
      } catch (error: any) {
        // console.log('Version Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  authenticateAction: (data: IAutheticateInput) =>
    new Authenticate().action(data),
  logoutAction: (history?: any) => new Logout().action(history),
  refreshTokenAction: (refreshToken: string, token: string) =>
    new RefreshToken().action({ refreshToken, token }),
  versionAction: () => new Version().action(),
};
